import { Navigate, useParams } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';

import { useJourneyEnhancedNavigation } from '@/store/v2/journeys/useJourneyEnhancedNavigation';
import {
  LockedLearningWarningModal,
  useLockedLearningWarningModalProps,
} from '@/administration/pages/Journey/common/modals/LockedLearningWarningModal';
import { useCourseViewerV2 } from '@/administration/pages/Course/store/courseViewer/useCourseViewerV2';
import { CourseStart } from '@/features/course/learner/pages/CourseStart';
import { CourseView } from '@/features/course/learner/pages/CourseView';
import { LayoutWrapper } from '@/component/App/component/LayoutWrapper/LayoutWrapper';
import { ROUTE_PATH } from '@/constants/routePaths';

export const Course = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const parsedCourseId = id ? parseInt(id) : NaN;

  const props = useCourseViewerV2({ id: parsedCourseId });

  const { currentItem, nextItem, journeyTitle, journeyId, allUpcomingItemsLocked, allUpcomingItemsUnlockAt } =
    useJourneyEnhancedNavigation({
      id: parsedCourseId,
    });
  const learningLockedModalProps = useLockedLearningWarningModalProps({
    parentJourneyId: journeyId,
    parentJourneyTitle: journeyTitle,
    isCurrentItemLock: currentItem?.isLocked,
  });

  if (isNaN(parsedCourseId)) {
    return <Navigate to={ROUTE_PATH.NOT_FOUND} />;
  }

  return (
    <>
      {learningLockedModalProps && <LockedLearningWarningModal {...learningLockedModalProps} />}
      <Routes>
        <Route
          path="/"
          element={
            <LayoutWrapper>
              <CourseStart
                {...props}
                nextItem={nextItem || undefined}
                allUpcomingItemsLocked={allUpcomingItemsLocked}
                allUpcomingItemsUnlockAt={allUpcomingItemsUnlockAt}
              />
            </LayoutWrapper>
          }
        />
        <Route path="/view/*" element={<CourseView {...props} />} />
      </Routes>
    </>
  );
};
